/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit No.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import Email from './Email/view.js'
import React from 'react'
import { css } from "emotion"

let styles = {}
styles.Vertical = css({label: 'Vertical',
  marginTop: 24})

export default function No({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  viewPath= "/App/MyAccount/Content/Profile/Content/Admins/Item/Content/Delete/OtherRoles/Content/Employee/Content/Delete/Content/WillBeDeleted/No"
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<div
 data-testid="No.Vertical"
 data-view-path="/App/MyAccount/Content/Profile/Content/Admins/Item/Content/Delete/OtherRoles/Content/Employee/Content/Delete/Content/WillBeDeleted/No"
 className={`views-block ${styles.Vertical}`}
>
<Email
 data-testid="No.Email"
 data-view-path="/App/MyAccount/Content/Profile/Content/Admins/Item/Content/Delete/OtherRoles/Content/Employee/Content/Delete/Content/WillBeDeleted/No"
viewPath={`${viewPath}/Email`}
/>
</div>
{children}
</React.Fragment>)
}